import { Link } from 'react-router-dom'
import classNames from 'classnames'

import styles from './styles.module.scss'

export const Scholarships = props => {
  const { data } = props
  return (
    <div className={styles.scholarships}>
      {data?.descriptions?.map((item, idx) => {
        return (
          <p className={styles.keyDetailsDesc} key={idx}>
            {item}
          </p>
        )
      })}
      {data?.highlightedPoint?.map((item, idx) => {
        return (
          <p className={classNames(styles.featuresDesc)} key={idx}>
            <span className={styles.icon}>
              <i className={classNames(styles.icon, 'fa-solid fa-brain')}></i>
            </span>
            <span className="text-bold">{item}</span>
          </p>
        )
      })}
      {data?.button &&
        data?.button.map((btn, idx) =>
          btn?.isExternal ? (
            <a
              className="btn btn-primary-gradient text-bold text-white text-upper rounded-0 px-30 py-10 mt-20"
              href={btn.link}
              target="_blank"
              rel="noreferrer"
              key={idx}
            >
              {btn?.buttonText}
            </a>
          ) : (
            <Link
              className="btn btn-primary-gradient text-bold text-white text-upper rounded-0 px-30 py-10 mt-20"
              to={btn?.link}
            >
              {btn?.buttonText}
            </Link>
          )
        )}
    </div>
  )
}
